
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisSarAircraftFixedwingIec as ObiAisSarAircraftFixedwingIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-sar-aircraft-fixedwing-iec.js';
 
 
 

 
 export const ObiAisSarAircraftFixedwingIec = createComponent({
   react: React,
   tagName: 'obi-ais-sar-aircraft-fixedwing-iec',
   elementClass: ObiAisSarAircraftFixedwingIecElement,
   events: {
     
   }
  });
 
 